import { TEDBOResursWEBBOKNINGSBAREnum } from '../../../../../../globalQueryTypes';
import { MeQuery } from '../Queries/MeQuery/_QueryTypes/MeQuery';
import {
  ResursQuery,
  ResursQuery_db_BOResurs_All,
} from '../Queries/ResursQuery/_QueryTypes/ResursQuery';
import { IResourceInfo } from './KalenderTypes';

export const convertResourceToResourceInfo = (
  resource: ResursQuery_db_BOResurs_All,
  userSign: string
): IResourceInfo => ({
  BO_RESURS_ID: resource.BO_RESURS_ID,
  resId: resource.id,
  resName: resource.BO_RESURS_NAMN,
  resType: resource._Associations?.ResRestyp?.BO_RESURSTYP_NAMN ?? '',
  resGQLId: resource.id,
  basTyp: resource._Associations?.ResRestyp.Bastyp ?? '',
  platsForsamlingId: resource._Associations?.Forsamling?.id,
  kanBoka:
    (resource.WEBBOKNINGSBAR &&
      (resource.WEBBOKNINGSBAR === TEDBOResursWEBBOKNINGSBAREnum.FRITT ||
        resource.WEBBOKNINGSBAR === TEDBOResursWEBBOKNINGSBAREnum.WEBFRI)) ||
    (userSign !== '' &&
      resource._Associations?.Anvandare?.SIGNATURE === userSign),
});

export const getLoggedInResource = (
  loggedInUserSign: string,
  resursData: ResursQuery
): IResourceInfo | undefined => {
  const resource = resursData.db?.BOResurs_All?.find(
    resurs =>
      loggedInUserSign.toLowerCase() ===
      resurs._Associations?.Anvandare?.SIGNATURE.toLowerCase()
  );

  if (!resource) {
    return undefined;
  }

  const resourceInfo = convertResourceToResourceInfo(
    resource,
    loggedInUserSign
  );

  return resourceInfo;
};

export const getDefaultBookingGroupName = (
  bookingGroup_data: MeQuery | undefined
) => {
  return bookingGroup_data?.me?.[0]?.bokningsgrupper?.find(
    bookingGroup => bookingGroup.ordinarie
  )?.namn;
};
